import { useState } from "react";
import { PortalContainer } from "../main/Portal"
import { ScreenTemplate } from "./ScreenTemplate"
import { Dialog } from "../Dialog";
import { useSelector } from "react-redux";
import { RdxType } from "../../../biz/data/Types";
import { store } from "../../../biz/data/redux/store";
import { useTranslation } from "react-i18next";

type DialogState = "none" | "dismissable" | "non-dismissable";

export const Home = () => {
    const [visible, setVisible] = useState<DialogState>("none");
    const { t } = useTranslation();

    const state = store.getState();

    return (
        <ScreenTemplate
            header={t("leftmenu_home")}
            text={t("screen_home_tagline")}
        //text="Startsida för advanced"
        >

            <br />
            <div>
                <button onClick={() => setVisible("dismissable")}>Dialog (dismissable)</button>
            </div>
            <br />
            <div>
                <button onClick={() => setVisible("non-dismissable")}>Dialog (non-dismissable)</button>
            </div>

            <br />
            <div>
                <h1>h1/Header 1</h1>
                <h2>h2/Header 2</h2>
                <h3>h3/Header 3</h3>
                <h4>h4/Header 4</h4>
                <h5>h5/Header 5</h5>
                <p>
                    p/Paragraph
                </p>

                <label htmlFor="demo">
                    label/Label
                </label>

                <input name="demo" id="demo" type="text" placeholder="text" />


                <button>Button</button>
            </div>

            <div>
                <div>
                    JSON State:
                </div>
                <div id="json">
                    {JSON.stringify(state)}
                </div>
            </div>

            <Dialog
                header="Dialog"
                visible={visible == "dismissable" || visible == "non-dismissable"}
                onCancel={() => setVisible("none")}
                cancelText="Stäng"
                clickOutside={() => { visible === "dismissable" && setVisible("none"); }}
            >
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Pellentesque suscipit ante quis massa aliquet, consequat
                    vulputate felis facilisis. Duis et mollis tortor.
                    Proin posuere, elit a sodales faucibus, urna neque dictum
                    ipsum, quis vehicula tortor ante ac justo. Aenean faucibus
                    quam ut metus pulvinar fringilla.
                </p>

                <p>
                    laskdakls
                </p>
            </Dialog>

        </ScreenTemplate>
    )
}
